import { render, staticRenderFns } from "./Group.modal.vue?vue&type=template&id=04aa47da"
import script from "./Group.modal.vue?vue&type=script&lang=js"
export * from "./Group.modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports